<template>

</template>

<script>
import * as mixins from '../mixins';

export default {
  created() {
    this.$router.push({ path: 'registration' });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Reload.vue